import axios from '@/axios';

// URL and endpoint constants
const INDEX_URL = '/external_resources';
const CONTENT_URL = '/where_learn_mores/1';
const OPINION_URL = 'quotes';

export default {
  index(page, succ) {
    axios.get(INDEX_URL, { params: { page } })
      .then((response) => { succ(response); });
  },
  content(succ) {
    axios.get(CONTENT_URL)
      .then((response) => { succ(response); });
  },
  getOpinion(succ) {
    axios.get(OPINION_URL)
      .then((response) => { succ(response); });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/learnMore.js